export default {
  GET_USER: "GET_USER",
  GET_ALERTS: "GET_ALERTS",
  GET_INIT_STATE_LOADED: "GET_INIT_STATE_LOADED",
  GET_PLAYERS_AND_TEAMS_VISIBLE: "GET_PLAYERS_AND_TEAMS_VISIBLE",
  GET_PLAYERS_AND_TEAMS: "GET_PLAYERS_AND_TEAMS",
  GET_USER_IS_TEAMBOT_ADMIN: "GET_USER_IS_TEAMBOT_ADMIN",
  GET_SHOW_NAVIGATION: "GET_SHOW_NAVIGATION",
  GET_ORGANIZATION: "GET_ORGANIZATION",
  GET_NAV_NOTIFICATIONS: "GET_NAV_NOTIFICATIONS",
  GET_TEAM: "GET_TEAM",
  GET_SELECTED_ORG_UNIT: "GET_SELECTED_ORG_UNIT",
  GET_COACH_HAS_PERMISSION: "GET_COACH_HAS_PERMISSION",
  GET_ORG_HAS_LIMITED_FUNCTIONALITY: "GET_ORG_HAS_LIMITED_FUNCTIONALITY",
  GET_ORG_SUBSCRIPTION_STATUS: "GET_ORG_SUBSCRIPTION_STATUS",
  GET_ORG_SUBSCRIPTION_STATUS_MESSAGE: "GET_ORG_SUBSCRIPTION_STATUS_MESSAGE",
  GET_COACH_HAS_PERMISSION_WITH_ORG_ID: "GET_COACH_HAS_PERMISSION_WITH_ORG_ID",
  GET_USER_HAS_NO_PLAYERS_OR_TEAMS: "GET_USER_HAS_NO_PLAYERS_OR_TEAMS"
};
